module.exports = __webpack_public_path__ + "static/media/480.25decf83.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-harness/light/480.png
// module id = 2140
// module chunks = 2